module.exports = __webpack_public_path__ + "static/twig-logo-57c2f65172416f9cae0bb6c79a0defb2.png";